import React, {Fragment} from 'react';
import { BrowserRouter as Router, Route} from 'react-router-dom';
import Articles from './articles';
import ArticleDetail from './articleDetail';
import Login from './login';

import { Provider } from 'react-redux'
import {store, persistor} from '../helpers/redux/store';
import { PersistGate } from 'redux-persist/integration/react';


class App extends React.Component {
  componentWillMount(){
    // persistor.purge();
  }
  
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Fragment>
              <Route exact path='/' component={Articles} />
              <Route exact path='/article/:id' component={ArticleDetail} />
            </Fragment>
          </Router>
        </PersistGate>
      </Provider>
    )
  }
}

export default App;